import { Flex, Text } from "@gravity-ui/uikit";
import { StatusesDto } from "definitions/exporter";

import { LogBlock } from "./components";
import css from "./LogViewer.module.scss";

export interface LogViewerProps {
  logs?: StatusesDto;
  failedReason?: string;
}

export const LogViewer = ({ logs, failedReason }: LogViewerProps) => {
  const success =
    !failedReason &&
    !logs?.errors?.messages?.length &&
    !logs?.warnings?.messages?.length;

  return (
    <div className={css.logContainer}>
      <Flex direction={"column"} gap={2}>
        {success && (
          <Text variant="subheader-2">Предупреждения и ошибки отсутствуют</Text>
        )}
        {failedReason && <LogBlock type="error" log={failedReason} />}
        {logs?.errors?.messages?.map((log, index) => {
          return <LogBlock type="error" log={log} key={`error.${index}`} />;
        })}

        {logs?.warnings?.messages?.map((log, index) => {
          return <LogBlock type="warning" log={log} key={`warning.${index}`} />;
        })}
      </Flex>
    </div>
  );
};
